<div class="flex-column menu-container">
  <div class="toggle-row">
    <span mat-dialog-title> {{ _data.title | translate }}</span>
    <button mat-icon-button class="close-icon" (click)="close()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  <mat-divider />
  @let content = _data.subtitle;
  @let subContent = _data.subtitleBottom;
  <mat-dialog-content>
    <div 
      class="upload-box scroll-Container"
      (dragover)="dragOver($event)"
      (drop)="dropOver($event)"
    >
      <input type="file" multiple (change)="filesPicked($event)" #fileInput hidden />
      @if(selectedFiles().length === 0) {
      <div class="center-align-content">
        <div class="upload-icon">
          <span class="material-symbols-outlined">cloud_upload</span>
        </div>
        <mat-dialog-content class="content-box">{{ content ?? '' | translate }}
          <span class="clickable-link" (click)="fileInput.click()" role="button" tabindex="0">{{ 'clickToUpload' | translate }}</span>
        </mat-dialog-content>
        <mat-dialog-content class="sub-content-box">{{ subContent ?? '' | translate }}</mat-dialog-content>
      </div>
    } @else {
      <div class="upload-icon">
        <span class="material-symbols-outlined">cloud_upload</span>
      </div>
      <mat-dialog-content class="content-box">{{ content ?? '' | translate }}
        <span class="clickable-link" (click)="fileInput.click()" role="button" tabindex="0">{{ 'clickToUpload' | translate }}</span>
      </mat-dialog-content>
      <mat-dialog-content class="sub-content-box">{{ subContent ?? '' | translate }}</mat-dialog-content>
    }
      @if (selectedFiles().length > 0) {
        <div>
          <table class="file-table">
            <thead>
              <tr>
                <th>{{ 'fileName' | translate }}</th>
                <th>{{ 'fileSize' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (file of selectedFiles(); track file.name) {
                <tr>
                  <td>{{ file.name }}</td>
                  <td>{{ file.size / 1024 / 1024 | number: '1.0-2' }} MB</td>
                  <td>
                    <button mat-icon-button (click)="removeFile(file)" class="button-height">
                      <span class="material-symbols-outlined icon-size">delete</span>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button class="secondary-button" [mat-dialog-close]>
      {{ 'cancel' | translate }}
    </button>
    <button
      mat-flat-button
      class="button-field"
      (click)="uploadFiles()"
      [disabled]="uploading() || selectedFiles().length === 0"
    >
      {{ 'upload' | translate }}
    </button>
  </mat-dialog-actions>
</div>
